export function mapObject<K extends string, T, U>(obj: Record<K, T>, f: (x: T) => U): Record<K, U> {
  // @ts-expect-error
  return Object.assign({}, ...Object.keys(obj).map((key) => ({ [key]: f(obj[key]) })))
}
